import "../styles/default.less"

const creatableStyle = {
  control: (state) => ({
    borderColor: state.isFocused ? "var(--primary)" : "var(--grey)", 
    boxShadow: state.isFocused ? `0 0 0 1px var(--primary)` : "none", 
    borderRadius: "var(--border-radius-medium)", 
    fontSize: "var(--font-size-medium)", 
    paddingLeft: "var(--dim-small)", 
    fontWeight: "var(--font-weight-normal)",
    transition: "all 0.3s ease",
  }),

  menu: () => ({
    backgroundColor: "var(--secondary)",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    zIndex: 100,
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "var(--primary)",
      border: "2px solid var(--white)", 
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "var(--white-opacity)",
    },
  }),

  menuList: () => ({
    maxHeight: "200px",
    backgroundColor: "var(--white)",
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "var(--primary)",
      borderRadius: "8px",
      border: "2px solid var(--white)",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "var(--white-opacity)",
    },
  }),

  option: (state) => ({
    color: state.isFocused || !state.isSelected ? "var(--black)" : "var(--white)",
    fontSize: "var(--font-size-medium)",
    fontWeight: "var(--font-weight-medium)",
    backgroundColor: state.isFocused
      ? "var(--primary-light)"
      : state.isSelected
      ? "var(--primary)"
      : "var(--white)",
    padding: "var(--dim-small)",
    cursor: "pointer",
    borderRadius: "var(--border-radius-small)",
    "&:active": {
      backgroundColor: "var(--primary)",
      color: "var(--white)",
    },
  }),

  placeholder: () => ({
    color: "var(--primary)",
    fontSize: "var(--font-size-medium)",
    fontStyle: "italic",
  }),

  input: () => ({
    color: "var(--black)",
    fontSize: "var(--font-size-medium)",
    fontWeight: "var(--font-weight-normal)",
    paddingTop: "var(--dim-small)",
    paddingBottom: "var(--dim-small)"
  }),

  clearIndicator: () => ({
    color: "var(--primary)",
    cursor: "pointer",
  }),

  dropdownIndicator: () => ({
    color: "var(--primary)",
    cursor: "pointer",
  }),

  indicatorSeparator: () => ({
    backgroundColor: "var(--primary)",
  }),

  // Style for selected tags in multi-value (selected tag chips)
  multiValue: (state) => ({
    backgroundColor: "var(--primary)", // Set primary background for selected tags
    borderRadius: "var(--border-radius-small)",
    display: "flex",
    alignItems: "center",
  }),
  multiValueLabel: (state) => ({
    color: "var(--white)", // Make the tag text white when selected
    fontWeight: "var(--font-weight-medium)",
    fontSize: "var(--font-size-medium)"
  }),
  multiValueRemove: (state) => ({
    color: "var(--white)",
    backgroundColor: "transparent",
    cursor: "pointer",
    ":hover": {
      backgroundColor: "var(--primary-dark, #0056b3)",
      color: "var(--white)",
    },
  }),
};

export default creatableStyle;